import zFold7_1 from "../../assets/samsungStore/carouselImages/carousal0/zFold7series/Zfold71.jpeg";
import zFold7_2 from "../../assets/samsungStore/carouselImages/carousal0/zFold7series/Zfold72.jpeg";
import zFold7_3 from "../../assets/samsungStore/carouselImages/carousal0/zFold7series/Zfold73.jpeg";
import zFold7_4 from "../../assets/samsungStore/carouselImages/carousal0/zFold7series/Zfold74.jpeg";
import zFold7_5 from "../../assets/samsungStore/carouselImages/carousal0/zFold7series/Zfold75.jpeg";
import zFold7_6 from "../../assets/samsungStore/carouselImages/carousal0/zFold7series/Zfold76.jpeg";
import zFold7_7 from "../../assets/samsungStore/carouselImages/carousal0/zFold7series/Zfold77.jpeg";

import zFlip7 from "../../assets/samsungStore/carouselImages/carousal0/zFlip7series/zFlip7_5.jpeg";
import zFlip7_1 from "../../assets/samsungStore/carouselImages/carousal0/zFlip7series/zFlip7_1.jpeg";
import zFlip7_2 from "../../assets/samsungStore/carouselImages/carousal0/zFlip7series/zFlip7_2.jpeg";
import zFlip7_3 from "../../assets/samsungStore/carouselImages/carousal0/zFlip7series/zFlip7_3.jpeg";
import zFlip7_4 from "../../assets/samsungStore/carouselImages/carousal0/zFlip7series/zFlip7_4.jpeg";
import zFlip7_5 from "../../assets/samsungStore/carouselImages/carousal0/zFlip7series/zFlip7_5.jpeg";
import zFlip7_6 from "../../assets/samsungStore/carouselImages/carousal0/zFlip7series/zFlip7_6.jpeg";

import zFlip7Fe_1 from "../../assets/samsungStore/carouselImages/carousal0/zFlip7FEseries/zFlip7FE_1.jpeg";
import zFlip7Fe_2 from "../../assets/samsungStore/carouselImages/carousal0/zFlip7FEseries/zFlip7FE_2.jpeg";

export const galaxyZSeries = [
  {
    id: 1,
    title: "Galaxy Z Fold 7",
    productImage: zFold7_1,
    images: [
      zFold7_1,
      zFold7_2,
      zFold7_3,
      zFold7_4,
      zFold7_5,
      zFold7_6,
      zFold7_7,
    ],
    // originalPrice: '₹ 13,999',
    discountedPrice: "1,74,999",
    // offerText: 'Flat ₹3,901 off',
    colors: ["Jet Black", "Blue Shadow", "Silver Shadow"],
    offers: [
      // { label: 'Offer', value: 'Get ₹1500 off on Axis Bank Credit Card' },
      // { label: 'EMI', value: 'Available from ₹999/month' },
    ],
    specifications: {
      // Audio: 'Dolby Atmos',
      // Battery: '5000mAh with 25W fast charging',
      // Controls: 'On-screen fingerprint scanner',
      // Compatibility: 'Works with Android 13',
      // Specs: {
      //   Chip: 'Exynos 1380',
      //   Connectivity: '5G, Wi-Fi 5',
      //   Case: 'Supports wireless charging',
      //   Weight: '202g',
      //   WaterResistance: 'IP67',
      //   Warranty: '1 year',
      // },
      Specs: [
        '8.0"inch main + 6.5"inch cover, both Dynamic AMOLED 2X Adaptive Refresh Rate up to 120 Hz',
        "Slimmest Samsung Foldable - 8.9 mm folded & 4.2mm unfolded.  Powered by Qualcomm Snapdragon 8 Elite",

        "Up to 16GB RAM & Up to 1TB Storage",
        "Triple Rear camera - 200 MP main (wide angle) with OIS + ProVisual Engine. 12 MP ultra-wide. 10MP telephoto with 3x optical zoom",
        "Front Camera - Dual 10 MP (one on cover, one under-display on inner screen)",
        "4400mah battery",
        "IP48-rated splash and dust resistance",
      ],
    },
  },
  {
    id: 2,
    title: "Galaxy Z Flip 7",
    productImage: zFlip7,
    images: [zFlip7_1, zFlip7_2, zFlip7_3, zFlip7_4, zFlip7_5, zFlip7_6],
    // originalPrice: '₹ 13,999',
    discountedPrice: "1,09,999",
    // offerText: 'Flat ₹3,901 off',
    colors: ["Jet Black", "Blue Shadow", "Coral Red"],
    offers: [
      // { label: 'Offer', value: 'Get ₹1500 off on Axis Bank Credit Card' },
      // { label: 'EMI', value: 'Available from ₹999/month' },
    ],
    specifications: {
      // Audio: 'Dolby Atmos',
      // Battery: '5000mAh with 25W fast charging',
      // Controls: 'On-screen fingerprint scanner',
      // Compatibility: 'Works with Android 13',
      // Specs: {
      //   Chip: 'Exynos 1380',
      //   Connectivity: '5G, Wi-Fi 5',
      //   Case: 'Supports wireless charging',
      //   Weight: '202g',
      //   WaterResistance: 'IP67',
      //   Warranty: '1 year',
      // },
      Specs: [
        '6.9"inch Dynamic AMOLED 2X, FHD+ (2520 x 1080)',
        '4.1"inch Super AMOLED Flex Window',
        "Adaptive Refresh Rate up to 120 Hz",
        "Slim Design - 6.5 mm unfolder & 13.7 mm folded",
        "Powered by Exynos 2500(3 nm process)",
        "Up to 12GB RAM & Up to 512GB Storage",
        "Dual Rear camera - 50 MP primary (wide, with dual Pixel AF + OIS). 12 MP ultra-wide",
        "Front Camera - 10 MP",
        "4300mah battery",
        "IP48-rated splash and dust resistance",
      ],
    },
  },
  {
    id: 3,
    title: "Galaxy Z Flip 7 FE",
    productImage: zFlip7Fe_1,
    images: [zFlip7Fe_1, zFlip7Fe_2],
    // originalPrice: '₹ 13,999',
    discountedPrice: "89,999",
    // offerText: 'Flat ₹3,901 off',
    colors: ["Black", "White"],
    offers: [
      // { label: 'Offer', value: 'Get ₹1500 off on Axis Bank Credit Card' },
      // { label: 'EMI', value: 'Available from ₹999/month' },
    ],
    specifications: {
      // Audio: 'Dolby Atmos',
      // Battery: '5000mAh with 25W fast charging',
      // Controls: 'On-screen fingerprint scanner',
      // Compatibility: 'Works with Android 13',
      // Specs: {
      //   Chip: 'Exynos 1380',
      //   Connectivity: '5G, Wi-Fi 5',
      //   Case: 'Supports wireless charging',
      //   Weight: '202g',
      //   WaterResistance: 'IP67',
      //   Warranty: '1 year',
      // },
      Specs: [
        '6.7"inch Dynamic AMOLED 2X, FHD+ (2640 x 1080)',
        '3.4"inch Super AMOLED panel',
        "Adaptive Refresh Rate for main display up to 120 Hz and for cover up to 60 Hz",
        "Powered by Exynos 2400(4 nm process)",
        "Up to 12GB RAM & Up to 256GB Storage",
        "Dual Rear camera - 50 MP main sensor with Dual Pixel AF & OIS. 12 MP ultra-wide lens",
        "Front Camera - 10 MP",
        "4000mah battery",
        "IP48-rated splash and dust resistance",
      ],
    },
  },
];
